import { AxiosResponse } from 'axios';
import { api } from './api';
import { authHeader } from './auth-header';

const authUrl = 'api/auth';

export const login = async (values: any): Promise<AxiosResponse<any>> => {
  return await api.post(`${authUrl}/login`, values);
};

export const signUp = async (values: any): Promise<AxiosResponse<any>> => {
  return await api.post('Account/SignUp', values);
};

export const fetchMe = async (): Promise<AxiosResponse<any>> => {
  return await api.get('account/me', authHeader());
};
